<template>
<div class="mTab">
    <router-link class="box" :class="[$route.name=='MReportIndex'?'selected':'']" :to="{name: 'MReportIndex'}">
        <div class="icon icon-index2"></div>
        <div class="name">首页</div>
    </router-link>
    <router-link class="box" :class="[$route.name=='MReportCategoryList'?'selected':'']" :to="{name: 'MReportCategoryList'}">
        <div class="icon icon-sort2"></div>
        <div class="name">分类</div>
    </router-link>
    <router-link class="box" :class="[$route.name=='Mme2'?'selected':'']" :to="{name: 'Mme2'}">
        <div class="icon icon-my2"></div>
        <div class="name">我的</div>
    </router-link>
</div>
</template>

<script>
export default {
    name: 'mTab',
    data() {
        return {}
    },
    methods: {},
    filters: {},
    watch: {},
    computed: {},
    components: {}
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
@import "~common/scss/variable";
.mTab {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    height: 0.88rem;
    background: $c-white;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-top: 0.01rem solid $line;
    font-size: 0.22rem;
    .box{
        color: $c-black;
        display: flex;
        justify-content: space-between;
        align-items: center;
        flex-direction: column;
        flex-grow: 1;
        .icon{
            width: 0.4rem;
            height: 0.4rem;
        }
        .name{
            line-height: 0.3rem;
        }
    }
    .selected{
        color: $c-blue;
    }
}
</style>